export default __webpack_public_path__ + "64257306c71e364243f97837f2e3fb34.png";